<template>
  <b-container>
    <div class="col-md-6">
      <h1>Cadastro de usuário</h1>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />

      <b-row class="mb-3 ml-0">
        <router-link :to="'./list'">
          <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
        </router-link>
      </b-row>
      <!-- 
    <br /> -->

      <b-form @submit.prevent="processForm">
        <crud-data
          :form="form"
          :modelstate="modelstate"
          :readonly="false"
          class="mb-4"
        ></crud-data>

        <!-- submit button -->
        <div class="field has-text-right">
          <b-button type="submit" :disabled="submitted">Salvar</b-button>
        </div>
      </b-form>
    </div>
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "Create",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CrudData: () => import("@/components_rms/System/User/CrudData.vue"),
  },
  props: {
    module: String,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "Usuário criado com sucesso",
      },
      submitted: false,
      modelstate: {},
      form: {
        nomeAcesso: "",
        senhaAcesso: "",
        documentNumber: "",
        email: "",
        nomeApresentacao: "",
        celular: "",
        telefone: "",
        entregador: false,
        plataforma: false,
        administrador: false,
        criadorFormularios: false,
        userType: 0,
      },
    };
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    processForm() {
      this.modelstate = {};
      this.submitted = true;
      this.$apiScheduler
        .post("/usuario/create", this.form)
        .then((response) => {
          this.submitted = false;
          if (response.data.success == false) {
            this.alert.error = response.data.title;
            this.$refs.danger.show();
          } else {
            this.$refs.alert.show();
            this.form = {
              nomeAcesso: "",
              senhaAcesso: "",
              email: "",
              nomeApresentacao: "",
              celular: "",
              telefone: "",
              note: "",
              entregador: false,
              plataforma: false,
              administrador: false,
              criadorFormularios: false,
            };
          }
        })
        .catch((error) => {
          console.log(error);
          this.submitted = false;
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          } else if (error.response.status == 500) {
            this.alert.error =
              error.response.status + " - " + error.response.statusText;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>